// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--5iBZ0";
export var borderRadius = "index-module--border-radius--4sIfL";
export var clearButtonStyles = "index-module--clear-button-styles--7cwVr";
export var counter = "index-module--counter--ssSvb";
export var price_per_day_pass = "index-module--price_per_day_pass--kv7n3";
export var titleFont = "index-module--title-font--qDdYB";